'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const Description_Description = require('../Description/Description.cjs.js');
const ErrorMessage_ErrorMessage = require('../ErrorMessage/ErrorMessage.cjs.js');
const Label_Label = require('../Label/Label.cjs.js');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const checkboxGroup = "_checkbox-group_1z9pi_1";
const optionsWrapper = "_options-wrapper_1z9pi_9";
const styles = {
	checkboxGroup: checkboxGroup,
	optionsWrapper: optionsWrapper
};

const CheckboxGroup = (_a) => {
  var { children, className, label, description, errorMessage, isRequired } = _a, props = tslib_es6.__rest(_a, ["children", "className", "label", "description", "errorMessage", "isRequired"]);
  return React__default.default.createElement(
    reactAriaComponents.CheckboxGroup,
    Object.assign({ className: clsx.clsx(className, styles.checkboxGroup), "data-zds": true }, props),
    label && React__default.default.createElement(Label_Label.Label, { isRequired }, label),
    React__default.default.createElement("div", { className: styles.optionsWrapper }, children),
    description && React__default.default.createElement(Description_Description.Description, null, description),
    React__default.default.createElement(ErrorMessage_ErrorMessage.ErrorMessage, null, errorMessage)
  );
};

exports.CheckboxGroup = CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.cjs.js.map
